import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGetClientStatementData } from '../api/types/leadership';

interface ILeadershipCapabilitySLModalProps {
  isOpen: boolean;
  modalType: 'add' | 'edit';
  initialValues: {
    id: string;
    name: string;
    description: string;
  };
}

const initialState: ILeadershipCapabilitySLModalProps = {
  isOpen: false,
  modalType: 'add',
  initialValues: {
    id: '',
    name: '',
    description: '',
  },
};

const leadershipPotentialSLModalSlice = createSlice({
  name: 'leadershipPotentialSLModal',
  initialState,
  reducers: {
    closeLeadershipPotentialSLModal: (state) => {
      state.isOpen = false;
      state.initialValues = initialState.initialValues;
    },
    openAddLeadershipPotentialSLModal: () => ({
      ...initialState,
      isOpen: true,
    }),
    openEditLeadershipPotentialSLModal: (
      state,
      action: PayloadAction<IGetClientStatementData>
    ) => {
      state.isOpen = true;
      state.modalType = 'edit';
      state.initialValues = {
        id: action.payload.id || '',
        name: action.payload.name || '',
        description: action.payload.description || '',
      };
    },
  },
});

export const leadershipPotentialSLModalActions =
  leadershipPotentialSLModalSlice.actions;
export const leadershipPotentialSLModalReducer =
  leadershipPotentialSLModalSlice.reducer;
